<template>
  <div>
    <el-steps :active="activeStep">
      <el-step v-for="(item, index) in compList" :key="item" @click.native="handleChangeStep(index)" />
    </el-steps>
    <keep-alive>
      <component :is="compList[activeStep - 1]"></component>
    </keep-alive>

    <div class="flex-center">
      <el-button type="primary" @click="handlePrev" v-if="activeStep !== 1">{{ $t('上一步') }}</el-button>
      <el-button type="primary" @click="handleNext" v-if="activeStep !== compList.length">{{ $t('下一步') }}</el-button>
      <el-button type="primary" @click="$router.back()" v-if="activeStep === compList.length">{{ $t('返回') }}</el-button>
    </div>
  </div>
</template>

<script>
import RecipeStep1 from "@/components/recipe-info/RecipeStep1";
import RecipeStep2 from "@/components/recipe-info/RecipeStep2";
import RecipeStep3 from "@/components/recipe-info/RecipeStep3";
import {scrollToTop} from "@/utils/common";
export default {
  name: "RecipeInfo",
  components: {RecipeStep3, RecipeStep2, RecipeStep1},
  data() {
    return {
      compList: ["RecipeStep1", "RecipeStep2", "RecipeStep3"],
      activeStep: 1,
    }
  },
  methods: {
    handleChangeStep(index) {
      this.activeStep = index + 1;
      scrollToTop(this);
    },
    handleNext() {
      if(this.activeStep === this.compList.length) return;
      this.activeStep ++;
      scrollToTop(this);
    },
    // 上一步
    handlePrev() {
      if (this.activeStep === 1) return;
      this.activeStep--;
      scrollToTop(this);
    }
  }
}
</script>

<style scoped>

.el-steps {
  margin-bottom: 44px;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}


</style>